import * as React from 'react';
import { GlobalStyle } from 'components/public-components/global-style';
import 'assets/favicon.ico';
import { Router } from 'react-router-dom';
import { sentryExceptionHandler } from 'sentry';
import history from 'lib/history';
import Routes from 'components/routes';
import { start } from 'lib/responsive';
import { ConfigProvider } from 'antd';
import { useObserver } from 'mobx-react';
import locale from '@/store/locale';

start();
class App extends React.Component {
  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    sentryExceptionHandler.call(this, error, errorInfo);
  }
  render() {
    return (
      <>
        <GlobalStyle />
        <Main />
      </>
    );
  }
}

const Main = () => {
  return useObserver(() => (
    <ConfigProvider locale={locale.locale}>
      <Router history={history}>
        <Routes />
      </Router>
    </ConfigProvider>
  ));
};

export default App;
